/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function*e(e){switch(e.type){case"object-id":case"unique-id-simple":return void(yield e.fieldName);case"unique-id-composite":return void(yield*e.fieldNames)}}export{e as getFeatureIdInfoFieldNames};
